const Menu = [
  {
    url: "/admin/dashboard",
    title: "Dashboard",
    icon: "flaticon2-dashboard",
    submenu: [
      {
        url: "",
        title: "Dashboard",
        module: "dashboard",
      },
    ],
  },
  {
    url: "/admin/member",
    title: "Member",
    icon: "flaticon-users",
    submenu: [
      {
        url: "",
        title: "Member",
        module: "member",
      },
      {
        url: "/checkin-member",
        title: "Checkin Member",
        module: "checkin-member",
      },
      {
        url: "/reservation-pt",
        title: "Reservation PT",
        module: "reservation-pt",
      },
      {
        url: "/leave-request",
        title: "Cuti Member",
        module: "leave-request",
      },
      {
        url: "/hold-package",
        title: "Hold Package",
        module: "hold-package",
      },
      {
        url: "/transfer-request",
        title: "Transfer Paket Member",
        module: "transfer-request",
      },
      {
        url: "/transfer-personal-trainer",
        title: "Transfer Personal Trainer",
        module: "transfer-personal-trainer",
      },
      {
        url: "/paid-trial-class",
        title: "Kelas Trial Berbayar",
        module: "paid-trial-class",
      },
    ],
  },
  {
    url: "/admin/package-management",
    title: "Paket",
    icon: "flaticon2-box",
    submenu: [
      {
        url: "/package",
        title: "Paket",
        module: "package",
      },
      {
        url: "/promo",
        title: "Promo",
        module: "promo",
      },
      {
        url: "/class-type",
        title: "Kelas",
        module: "class-type",
      },
      {
        url: "/class-instructor",
        title: "Instruktur Kelas",
        module: "class-instructor",
      },
      {
        url: "/class-schedule",
        title: "Jadwal Kelas",
        module: "class-schedule",
      },
    ],
  },
  {
    url: "/admin/sales-management",
    title: "Sales",
    icon: "flaticon-cart",
    submenu: [
      {
        url: "/sales",
        title: "Sales",
        module: "sales",
      },
      {
        url: "/payment-method",
        title: "Metode Pembayaran",
        module: "payment-method",
      },
      {
        url: "/bank",
        title: "Bank Pembayaran",
        module: "bank",
      },
    ],
  },
  {
    url: "/admin/apps-management",
    title: "Apps",
    icon: "flaticon-apps",
    submenu: [
      {
        url: "/announcement",
        title: "Pengumuman",
        module: "announcement",
      },
    ],
  },
  {
    url: "/admin/stock-merchandise",
    title: "Stock Merchandise",
    icon: "flaticon2-box",
    submenu: [
      {
        url: "/merchandise",
        title: "Merchandise",
        module: "merchandise",
      },
      {
        url: "/merchandise-in-log",
        title: "Restock Merchandise",
        module: "merchandise-in-log",
      },
      {
        url: "/merchandise-out-log",
        title: "Pengambilan Merchandise",
        module: "merchandise-out-log",
      },
    ],
  },
  {
    url: "/admin/commission-management",
    title: "Komisi",
    icon: "flaticon-coins",
    submenu: [
      {
        url: "/commission-config",
        title: "Pengaturan Komisi",
        module: "commission-config",
      },
      {
        url: "/commission-summary",
        title: "Ringkasan Komisi",
        module: "commission-summary",
      },
    ],
  },

  {
    url: "/admin/user-management",
    title: "Manajemen Karyawan",
    icon: "flaticon-user",
    submenu: [
      {
        url: "/user",
        title: "Pengguna",
        module: "user",
      },
      {
        url: "/role",
        title: "Role",
        module: "role",
      },
      {
        url: "/module",
        title: "Modul",
        module: "module",
      },
      {
        url: "/action",
        title: "Tindakan",
        module: "action",
      },
    ],
  },

  {
    url: "/admin/files",
    title: "Pengaturan Dokumen",
    icon: "flaticon-file",
    submenu: [
      {
        url: "/file",
        title: "Dokumen",
        module: "file",
      },
      {
        url: "/file-category",
        title: "Format Dokumen",
        module: "file-category",
      },
    ],
  },

  {
    url: "/admin/scanner",
    title: "Scanner",
    icon: "flaticon2-photo-camera",
    submenu: [
      {
        url: "/",
        title: "Check-In",
        module: "scanner",
      },
    ],
  },
];

export default Menu;
